import type { GlobalConfigProvider } from 'tdesign-react/es/config-provider/type';
import enUS from 'tdesign-react/es/locale/en_US';
import zhCN from 'tdesign-react/es/locale/zh_CN';
import { LANG_TYPE } from '@tencent/oneid-utils';
import i18n from 'common/locales';

/** 语言标识 → TDesign 语言包映射 */
const TDESIGN_LOCALE_MAP: Record<string, GlobalConfigProvider> = {
  [LANG_TYPE.ZH_CN]: zhCN,
  [LANG_TYPE.EN_US]: enUS,
};

/** 根据当前语言偏好获取 TDesign 组件库对应的语言包配置 */
export function getTDesignLocale(): GlobalConfigProvider {
  const lang = i18n.language;
  return TDESIGN_LOCALE_MAP[lang] ?? zhCN;
}
